import { render, staticRenderFns } from "./InputMinusPlus.vue?vue&type=template&id=b87dd04c&scoped=true&"
import script from "./InputMinusPlus.vue?vue&type=script&lang=js&"
export * from "./InputMinusPlus.vue?vue&type=script&lang=js&"
import style0 from "./InputMinusPlus.vue?vue&type=style&index=0&id=b87dd04c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87dd04c",
  null
  
)

export default component.exports